import { render, staticRenderFns } from "./rechargeRecord.vue?vue&type=template&id=33b2fc20&scoped=true"
import script from "./rechargeRecord.vue?vue&type=script&lang=js"
export * from "./rechargeRecord.vue?vue&type=script&lang=js"
import style0 from "./rechargeRecord.vue?vue&type=style&index=0&id=33b2fc20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b2fc20",
  null
  
)

export default component.exports